export const environment = {
  name: 'prod',
  production: true,
  endpoint: 'https://localhost:7239/',
  timeStamp: '06/10/2026 04:10:17 PM CEST',
  commitSha: 'ae9fe91',
  googleAnalyticsId: 'UA-000000000-0'
};


